import React from 'react';
import { Box } from '@mui/material';

/**
 * A reusable scrollable container with default max height and subtle scrollbars + shadow cue.
 */
function ScrollBox({ children, maxHeight = 300, sx = {} }) {
  return (
    <Box
      sx={{
        position: 'relative',
        maxHeight,
        overflowY: 'auto',
        pr: 1,
        border: '1px solid #444',
        borderRadius: 2,
        backgroundColor: 'background.paper',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555',
        },
        // Optional: subtle shadow at bottom to hint scrolling
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '20px',
          background: (theme) =>
            `linear-gradient(to top, ${theme.palette.background.paper}, transparent)`,
          pointerEvents: 'none',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default ScrollBox;
